import React, { useEffect } from 'react';
import styles from './FormPreview.module.scss';
import Input from 'component/atom/forms/input/input/Input';
import Button from 'component/atom/forms/button/Button';
import { useFetch } from 'hooks/useFetch';
import { workflow } from 'hooks/endpoints';
import Loader from 'component/atom/loader/Loader';
import GenerateForm from 'component/organism/chat-console/components/bot-response/factory/components/form/GenerateForms';
const FormPreview = ({ formId, isNode }) => {
  const {
    data: formPreview,
    refetch,
    isPending: isShowingForm,
  } = useFetch(['getFormsById', formId], workflow.getFormById(formId), {
    enabled: !!formId,
  });

  useEffect(() => {
    if (formId) {
      refetch();
    }
  }, [formId]);

  if (isShowingForm && formId) {
    return (
      <div className={styles.cont}>
        <Loader isComponent />
      </div>
    );
  }

  return formPreview?.data ? (
    <div className={styles.cont}>
      <div>
        <p className={styles.title}>Preview</p>
        <p className={styles.subTitle}>{formPreview?.data?.formTitle}</p>
      </div>
      <GenerateForm
        step={{
          value: { formDetails: formPreview?.data?.formDetails },
          buttonText: formPreview?.data?.buttonText,
        }}
        classname={styles.form}
        isNode={isNode}
      />
    </div>
  ) : null;
};

export default FormPreview;
